import React from 'react';
import classNames from 'classnames';
import css from './Button.module.css';

/**
 * Custom Button component matching shadcn/ui design
 * Built with vanilla React + CSS Modules
 */
export const Button = ({
  children,
  variant = 'default',
  size = 'default',
  onClick,
  disabled = false,
  className,
  type = 'button',
  ...props
}) => {
  const buttonClasses = classNames(
    css.button,
    css[variant],
    css[size],
    {
      [css.disabled]: disabled,
    },
    className
  );

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

// Support both default and named imports
export default Button;
